import { Component, EventEmitter, HostBinding, Input, Output, ViewChild } from "@angular/core";
import { VToggleComponent } from "../../_forms/v-toggle/v-toggle.component";
import './v-toggle-list-item.component.scss';

@Component({
    selector: "v-toggle-list-item",
    template: require("./v-toggle-list-item.component.html")
})
export class VToggleListItemComponent {
    @HostBinding("class.has-description") @Input() description: string;
    @Input() title: string;
    @Input() disabled: boolean;

    @Input() value: boolean;
    @Output() valueChange = new EventEmitter<boolean>();
    @Output() onChanged = new EventEmitter<boolean>();

    @ViewChild(VToggleComponent) toggleComponent: VToggleComponent;

    constructor() { }

    onToggled(): void {
        this.valueChange.emit(this.value);
        this.onChanged.emit(this.value);
    }

    toggle(): void {
        this.toggleComponent?.toggle();
    }
}
